import type { AppDefinition } from '../types';
import { CardBack } from './CardBack';
import { CardFront } from './CardFront';
import { MissRow } from './MissRow';
import type { SubstantivoPayload } from './types';

/**
 * Gêneros — `o` or `a`, and the plural.
 *
 * The first app in this tree that does not teach German, and the proof that the
 * engine never cared. One exercise is one `cards` row, the article and plural
 * fit the polymorphic payload every other deck uses, and `translations` was
 * already a language-keyed map — so a Portuguese deck glossed in German and
 * English needed no schema at all.
 *
 * The mirror of Der·Die·Das, one gender lighter, and the sibling of
 * Substantivos — which asks what the same word means. Same list, two decks,
 * separate progress, exactly as the German pair has always worked. That difference is the product:
 * German taught this learner that gender must be memorised word by word, and
 * Portuguese mostly reads it off the ending. The deck's real content is the
 * hundred-odd words where that relief is genuine, and the eight where it is a
 * trap — `o problema`, `a mão` — which the card back names rather than leaving
 * to be discovered.
 */
export const generosApp: AppDefinition<SubstantivoPayload> = {
  id: 'generos',
  display_name: 'Gêneros',
  CardFront,
  CardBack,
  MissRow,
};
